import { MyMetricDefinition } from 'libs/end-to-end/src/my-metric-definition';
import { FocusAreaDefinition } from 'libs/end-to-end/src/types/databases/focus-areas/focus-area-definition';

export const getBiasAnalysisControlVariableDisplayNames = ({
  metricDefinition,
  focusAreaDefinition,
}: {
  metricDefinition: MyMetricDefinition | null;
  focusAreaDefinition: FocusAreaDefinition;
}): string[] => {
  if (!metricDefinition) {
    return [];
  }

  return [
    ...metricDefinition.staticControlVariableDefinitions.map(
      (variable) => variable.name,
    ),
    ...focusAreaDefinition.controlVariables.map(
      (controlVariable) => controlVariable.displayName,
    ),
  ];
};
